export interface ContactGroupRequestModel {
  name: string;
  description: string;
}
